import { SpacingSelectorStoryblok } from '../types/bloks/spacingSelector';

export function getSpacingFromStory(story: SpacingSelectorStoryblok[], noUnits = false) {
  const value = story?.[0]?.spacing?.content?.value;
  if (!value) return;
  return noUnits ? value : `${value}rem`;
}
